module.exports = __webpack_public_path__ + "static/media/kasia.41c5b3c3.png";